import { render } from "./PayImageWallEditModal.vue?vue&type=template&id=4644f41d&scoped=true"
import script from "./PayImageWallEditModal.vue?vue&type=script&lang=js"
export * from "./PayImageWallEditModal.vue?vue&type=script&lang=js"

import "./PayImageWallEditModal.vue?vue&type=style&index=0&id=4644f41d&scoped=true&lang=less"
import "./PayImageWallEditModal.vue?vue&type=style&index=1&id=4644f41d&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4644f41d"]])

export default __exports__